<template>
  <teleport to="#teleport-modal-right">
    <transition name="fade">
      <div
        v-show="showModal === true"
        v-body-scroll-lock="showModal === true"
        id="modalRight"
        class="fixed top-0 left-0 w-full max-h-full z-40 overflow-y-scroll"
        style="background: rgba(0, 0, 0, 0.3); scroll-behavior: smooth"
        :class="{
          'opacity-0': !modalOpacity,
          'opacity-100': modalOpacity,
        }"
      >
        <div class="flex m-auto">
          <div class="flex-1" @click="this.$emit('close-modal')"></div>
          <div
            class="bg-white m-auto mr-0 overflow-hidden"
            :style="{
              width: `${modalWidth || 960}px`,
            }"
          >
            <slot @close-modal="this.$emit('close-modal')"></slot>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    modalWidth: Number,
    modalOpacity: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close-modal'],
};
</script>
